// extracted by mini-css-extract-plugin
export default {"mclCell":"mclCell---U0x8k mclCell---FSW_H mclCellStyle---eUByQ"};